import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../Configuration/configuration.service';
import { SessionTimeOutModel } from '../../Data/Models/Common/session-time-out-model';

@Injectable({
  providedIn: 'root'
})
export class SeesionTimeoutService {

  baseURL: string
  constructor(private http: HttpClient, private configService: ConfigurationService) {
    this.baseURL = this.configService.getAPIBaseUrl();
  }
  GetUserSession(UserId: number): Observable<SessionTimeOutModel> {
    var url = `${this.baseURL}/SessionTimeOut/RetrieveUserSession?UserId=${UserId}`
    return this.http.get<SessionTimeOutModel>(url);
  }
  UpdateSession(sessionTimeOut: SessionTimeOutModel): Observable<SessionTimeOutModel> {
    var url = `${this.baseURL}/SessionTimeOut/UpdateUserSession`
    return this.http.post<SessionTimeOutModel>(url, sessionTimeOut);
  }
}
